import { IMachine } from '../machines/machines'
import { l } from '../lib/imports'
import { advanceTask2 } from './advanceTask'
import { IJob, IJobType, ITask, ITaskType } from './jobs'
import { IMonster } from '../monsters/monsters'
import { IBlueprint } from '../blueprints/blueprints'
import { IBlueprintData } from '../blueprints/blueprintsData'
import { stacks } from '../entities/stacks-sidecar'

let jobLogging = true

export function report() {}

export function succeedJob(job: IJob) {
  if (jobLogging) {
    console.log('++ completed job ' + job.type)
  }
  job.isComplete = true
  return false
}

export function failJob(job: IJob, reason: string) {
  if (jobLogging) {
    console.warn('!! failed job ' + job.type + ' for job ' + job.type, reason)
  }
  job.isFailed = true
  return false
}
export function cancelJob(job: IJob, reason: string) {
  if (jobLogging) {
    console.warn(
      '!! cancelled job ' + job.type + ' for job ' + job.type,
      reason,
    )
  }
  job.isFailed = true
  return false
}
export function failTask(job: IJob, task: ITask, reason: string) {
  if (jobLogging) {
    console.warn('!! failed task ' + task.type + ' for job ' + job.type, reason)
  }

  let hardFail = true
  if (task.onFail) {
    hardFail = task.onFail()
  }

  if (hardFail) {
    job.isFailed = true
    task.isFailed = true
  }
  task.isComplete = true
  return false
}

export function succeedTask(job: IJob, task: ITask) {
  if (jobLogging) {
    console.log('++ ok task ' + task.type + ' for ' + job.type)
  }

  task.isComplete = true
}

export function runTasks(job: IJob) {
  if (!job.tasks || job.tasks.length === 0) {
    return false
  }

  for (let i = 0; i < job.tasks.length; i++) {
    let st = job.tasks[i]
    if (st.isFailed) {
      failJob(job, 'task failed')
      return true
    }
    if (st.isComplete) {
      continue
    }
    advanceTask2(job, st)
    return true
  }
  return false
}

export function runSubtasks(job: IJob, task: ITask) {
  if (!task.subtasks || task.subtasks.length === 0) {
    return false
  }

  for (let i = 0; i < task.subtasks.length; i++) {
    let st = task.subtasks[i]
    if (st.isFailed) {
      failTask(job, task, 'subtask failed')
      return true
    }
    if (st.isComplete) {
      continue
    }
    advanceTask2(job, st)
    return true
  }
  return false
}

// export function succeedSubtask(job: IJob, task: ITask) {
//   if (jobLogging) {
//     console.log('++ ok subtask ' + task.type + ' for ' + job.type)
//   }

//   // task.isComplete = true
// }

export function assertTrue(
  condition: boolean,
  ...error: string[]
): asserts condition {
  if (!condition) {
    let message = ['ERROR JOB assert failed', ...error]
    console.error(...message)
    throw new Error(l.join(message, ' | '))
  }
}
export function assertNotNil<T>(
  testee: T | null,
  ...error: string[]
): asserts testee {
  assertTrue(testee != null, ...error)
}
export function assertFalse(condition: boolean, ...error: string[]) {
  assertTrue(!condition, ...error)
}

export function assertTask(task: ITask) {
  assertTrue(task != null, 'lost task')
  return task
}

export function assertMachine(
  job: IJob,
  filter: (m: IMachine) => boolean,
): IMachine {
  assertNotNil(job.machine)
  assertTrue(filter(job.machine), 'no machine for job')
  return job.machine as IMachine
}

export function assertStack(job: IJob) {
  assertNotNil(job.stack, 'no stackk for job')
  stacks.ensureStack(job.stack)
  return job.stack
}

export function assertTaskType(task: ITask, taskType: ITaskType) {
  assertFalse(task.type !== taskType, 'wrong task type', task.type, taskType)
  return task
}

export function assertJobType(job: IJob, jobType: IJobType) {
  assertFalse(job.type !== jobType, 'wrong job type', job.type, jobType)
  return job
}

export function assertReserved(job: IJob): IMonster {
  assertNotNil(job.reservedBy, job.type, 'not reserved')
  return job.reservedBy as IMonster
}

export function assertBlueprint(job: IJob): IBlueprint {
  assertNotNil(job.blueprint, job.type, 'no blueprint!')
  return job.blueprint as IBlueprint
}

export function isWaitingForPathOrMovement(job: IJob) {
  if (job.findPathId) {
    return true
  }
  if (job.reservedBy && job.reservedBy.path.length > 0) {
    return true
  }
}

export function addTask(job: IJob, task: ITask) {
  if (job.tasks.length > 50) {
    failJob(job, 'too many subtasks, probably infinite loop')
    return
  }
  job.tasks.push(task)
}
